import { SkeletonItem } from '@capsicum/common-web';
import styled from 'styled-components';

export const V2FTSupportedDestinationsSkeleton = () => (
	<S.Wrapper aria-label="Loading...">
		<SkeletonItem height={150} width="100%"></SkeletonItem>
	</S.Wrapper>
);

namespace S {
	export const Wrapper = styled.div`
		flex: 1;
	`;
}
